import { createContext, useContext } from 'react';
export const GlobalNavigationConfigContext = createContext({
    hasCartLink: true,
});
/**
 * Convenience hook which provides the context instance.
 */
export const useGlobalNavigationConfig = () => useContext(GlobalNavigationConfigContext);
